import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const ClientRouter = lazy(() => import("./ClientRouter"));
const AdminRouter = lazy(() => import("./AdminRouter"));

const AppRouter = () => {
  const envType = process.env.REACT_APP_ENV_TYPE;
  const enableClientRoutes = envType !== "ADMIN";
  const enableAdminRoutes = envType !== "CLIENT";
  const defaultPath = enableClientRoutes ? "/login" : "/center/login";

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Navigate to={defaultPath} replace />} />
        {enableAdminRoutes ? (
          <Route path="/center/*" element={<AdminRouter />} />
        ) : null}
        {enableClientRoutes ? (
          <Route path="*" element={<ClientRouter />} />
        ) : (
          <Route path="*" element={<Navigate to={defaultPath} replace />} />
        )}
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
